import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { compose, lifecycle } from 'recompose';
import { withLoadingComponent, withErrorComponent } from '../components/loading';
import TransactionDay from '../components/transactionDay/TransactionDay';
import {fetchTransactionDay} from "../store/actions/transactionday";

const mapStateToProps = (state, ownProps) => {
    return {
        salesByCurrencyHour: state.transactionday.transactionday?(state.transactionday.transactionday.salesByCurrencyHour?state.transactionday.transactionday.salesByCurrencyHour:null):null,
        mobile: state.browser.lessThan.medium,
        mainCurrency: state.transactionday.transactionday?(state.transactionday.transactionday.mainCurrency?state.transactionday.transactionday.mainCurrency:null):null,
        transactions: state.transactionday.transactionday?(state.transactionday.transactionday.transactions?state.transactionday.transactionday.transactions:null):null,
        branchId: ownProps.match.params.branchId,
        day: ownProps.match.params.transactionDay,
        ...state.transactionday,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const transactionDay = ownProps.match.params.transactionDay;
    const branchId = ownProps.match.params.branchId;

    return {
        fetchTransactionDay: () => dispatch(fetchTransactionDay(branchId, transactionDay)),
    }
};

const lifecycleValue = {
    componentWillMount() {
        this.props.fetchTransactionDay();
    },
    componentDidUpdate() {
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 0);
    }
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle(lifecycleValue),
    withErrorComponent,
    withLoadingComponent
)(TransactionDay);






// WEBPACK FOOTER //
// ./src/containers/TransactionDayContainer.js